module.exports = __webpack_public_path__ + "img/chris-new.59a30419.svg";